import { render } from "./TunsoftButton.vue?vue&type=template&id=7f8ac6af&scoped=true"
import script from "./TunsoftButton.vue?vue&type=script&lang=js"
export * from "./TunsoftButton.vue?vue&type=script&lang=js"

import "./TunsoftButton.vue?vue&type=style&index=0&id=7f8ac6af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8ac6af"]])

export default __exports__